import styled from "styled-components";

export default styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 25px;
    color: #4c4c4c;
    letter-spacing: 0.25px;
`;
